import { AuthCode, SecurityIssueResponse } from 'adc-sirius-module-common';
import i18n from '../utilities/i18n';

/**
 * @param {SecurityIssueResponse} response returned from a failed authentication attempt, containing details about the failure
 * @param {string} defaultErrorKey translation key for the default error message to use if a specific message for the error code is not found
 * @returns {string} translated error message string corresponding to the authentication failure
 */
export const getAuthenticationError = (
  response: SecurityIssueResponse,
  defaultErrorKey: string,
) => {
  const { code, data } = response;

  const defaultValue = i18n.t(defaultErrorKey);

  let tokens = {};
  let plural = true;

  switch (code) {
    case AuthCode.PasswordGenerations:
    case AuthCode.PasswordRepeat:
    case AuthCode.PasswordSequential:
      tokens = {
        count: data.limit,
      };
      plural = data.limit > 1;
      break;
    case AuthCode.PasswordChangeLock:
      tokens = {
        count: data.interval,
      };
      plural = data.interval > 1;
      break;
  }

  return i18n.t(`SecurityRules.${code}${plural ? '' : '_1'}`, {
    defaultValue,
    ...tokens,
  });
};
